module.exports = __webpack_public_path__ + "static/media/our_process.1f15d77c.png";